import CompanyService from "../../../../services/CompanyService";
import { TranslationService } from "../../../../services/TranslationService";
import { formatDateDigits } from "../../../../utils/FormatUtils";
import { ActivityOrigin } from "../../../client/activity/entities/AcitivityListResponse";
import { InvoiceGetResponse } from "../entities/InvoiceGetResponse";

export interface InvoiceStatusHistoryProps {
  statusLogsHistory: Array<IOStatusLog>;
  item: InvoiceGetResponse.Item;
}

export interface IOStatusLog {
  IOStatusLogID: number;
  IOID: number;
  IOStatusID: number;
  UserID: number;
  Created: string;
  BlobData: string;
  Origin?: number;
}

const InvoiceStatusHistory = ({
  statusLogsHistory,
  item
}: InvoiceStatusHistoryProps) => {
  const { translate } = TranslationService;
  //const additionalIO = CompanyService.getAdditionalDefinitions().filter(x => x.Entity === Entities.Invoice && x.IOStatusDependencies?.length > 0);
  const statusList = CompanyService.getIoStatus();
  const userlist = CompanyService.getUsers();

  const getIOStatusDescription = (ioStatusId: number) => {
    let statusDescription = statusList.find((x) => x.IOStatusID === ioStatusId);
    return statusDescription ? statusDescription.Value : "";
  };

  const getUserName = (userId: number) => {
    let userName = userlist.find((x) => x.Id === userId?.toString());
    return userName ? userName.Value : "";
  };

  return (
    <>
      <table className="table table-sm table-striped">
        <thead>
          <tr>
            <th>{translate.Date}</th>
            <th>{translate.Status}</th>
            <th>{translate.AdditionalData}</th>
            <th>{translate.User}</th>
          </tr>
        </thead>
        <tbody>
          {statusLogsHistory.map((x, i) => {
            return (
              <tr key={x.IOStatusID} className="show-child-on-hover">
                <td style={{ width: 70 }}>
                  {formatDateDigits(new Date(x.Created))}
                </td>
                <td>{getIOStatusDescription(x.IOStatusID)}</td>
                <td>{x.BlobData?.replaceAll("<br />", "\n")}</td>
                <td>
                  {x.Origin === ActivityOrigin.Autonomous
                    ? translate.AIAgent
                    : getUserName(x.UserID)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default InvoiceStatusHistory;
